import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export const useScrollableTagsStyles = makeStyles()((theme: Theme) => ({
  scrollContainer: {
    display: 'flex',
    position: 'relative',
    overflowX: 'auto',
    overflowY: 'hidden',
    width: '100%',
    paddingBottom: '4px',

    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      width: '32px',
      zIndex: 1,
    },
    '&::before': {
      left: '-10px',
      background: `linear-gradient(to right, ${theme.palette.background.paper} 0%, transparent 100%)`,
    },
    '&::after': {
      right: '0',
      background: `linear-gradient(to left, ${theme.palette.background.paper} 0%, transparent 100%)`,
    },
  },

  scrollContent: {
    display: 'flex',
    alignItems: 'center',
    overflowY: 'hidden',
    position: 'relative',
    width: '100%',
    gap: '4px',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
}));
